import block from './icons/block.svg';
import btnAdd from './icons/btn-add.svg';
import checkbox from './icons/checkbox.svg';
import checkboxWhite from './icons/checkbox_white.svg';
import collapseIcon from './icons/collapse_icon.svg';
import cross from './icons/cross.svg';
import expandIcon from './icons/expand_icon.svg';
import gear from './icons/gear.svg';
import logo from './icons/logo.svg';
import logoElevate from './icons/logo-elevate.svg';
import pencil from './icons/pencil.svg';
import search from './icons/search.svg';
import tailSpin from './icons/tail-spin.svg';
import trash from './icons/trash.svg';
import minimize from './icons/minimize.svg';
import remove from './icons/remove.svg';

import questionTypeCheckbox from './icons/question_type_checkbox.svg';
import questionTypeCurrency from './icons/question_type_currency.svg';
import questionTypeDate from './icons/question_type_date.svg';
import questionTypeDocument from './icons/question_type_document.svg';
import questionTypeDropdown from './icons/question_type_dropdown.svg';
import questionTypeFile from './icons/question_type_file.svg';
import questionTypeNumber from './icons/question_type_number.svg';
import questionTypeTable from './icons/question_type_table.svg';
import questionTypeText from './icons/question_type_text.svg';
import questionTypeRelation from './icons/question_type_relation.svg';
import questionTypeSmileyRating from './icons/question-type-smiley-rating.svg';
import questionTypeAutofill from './icons/question_type_autofill.svg';
import questionTypeStarRating from './icons/question_type_star_rating.svg';
import questionTypeRadio from './icons/question_type_radio.svg';
import questionTypeAudio from './icons/question_type_audio.svg';

import newPage from './icons/new-page.svg';
import user from './icons/user.svg';
import users from './icons/users.svg';
import masterdata from './icons/masterdata.svg';
import jobs from './icons/jobs.svg';
import help from './icons/help.svg';
import check from './icons/check.svg';
import dash from './icons/dash.svg';
import usersBig from './icons/Users-icon.svg';
import masterdataBig from './icons/Masterdata-icon.svg';
import jobsBig from './icons/Jobs-icon.svg';
import dashboard from './icons/Dashboard.svg';
import hand from './icons/stop-icon.svg';
import arrowL from './icons/arrow-l.svg';
import arrowR from './icons/arrow-r.svg';
import arrowLeft from './icons/arrowLeft.svg';
import arrowRight from './icons/arrowRight.svg';
import expand from './icons/expand.svg';
import plus from './icons/plus.svg';
import clone from './icons/clone.svg';
import funnel from './icons/funnel.svg';
import download from './icons/download.svg';
import eye from './icons/eye.svg';
import eyeCross from './icons/eye-cross.svg';
import serviceIconBlue from './icons/service-icon-book-blue.svg';
import miscObjects from './icons/misc_objects.svg';
import text from './icons/text.svg';
import doubleTable from './icons/double-table.svg';
import table from './icons/table.svg';
import chart from './icons/chart.svg';
import language from './icons/language.svg';
import sortAZ from './icons/sort-a-z.svg';
import sortZA from './icons/sort-z-a.svg';
import notifications from './icons/notifications.svg';
import information from './icons/information.svg';
import informationCircle from './icons/information-circle.svg';
import alert from './icons/alert.svg';
import notificationsBadge from './icons/notifications-badge.svg';

import severityCritical from './icons/severity-critical.svg';
import severityMajor from './icons/severity-major.svg';
import severityMinor from './icons/severity-minor.svg';
import severityModerate from './icons/severity-moderate.svg';

import capApproved from './icons/cap_approved.svg';
import capPending from './icons/cap_pending.svg';
import capRejected from './icons/cap_rejected.svg';

import folder from './icons/folder.svg';
import notAssigned from './icons/not_assigned.svg';
import info from './icons/info.svg';
import error from './icons/error.svg';

import reportToolBreak from './icons/report-tool/icons/break.svg';
import reportToolChart from './icons/report-tool/icons/chart.svg';
import reportToolChartLabel from './icons/report-tool/icons/chart-label.svg';
import reportToolCustom from './icons/report-tool/icons/custom.svg';
import reportToolDoubleTable from './icons/report-tool/icons/double-table.svg';
import reportToolLabel from './icons/report-tool/icons/label.svg';
import reportToolSubtitle from './icons/report-tool/icons/subtitle.svg';
import reportToolTable from './icons/report-tool/icons/table.svg';
import reportToolText from './icons/report-tool/icons/text.svg';

import reportToolComponentAttachments from './icons/report-tool/components/attachments.svg';
import reportToolComponentBreak from './icons/report-tool/components/break.svg';
import reportToolComponentBreakdown from './icons/report-tool/components/breakdown.svg';
import reportToolComponentChart from './icons/report-tool/components/chart.svg';
import reportToolComponentChartLabel from './icons/report-tool/components/chart-label.svg';
import reportToolComponentDoubleTable from './icons/report-tool/components/double-table.svg';
import reportToolComponentFindings from './icons/report-tool/components/findings.svg';
import reportToolComponentLabel from './icons/report-tool/components/label.svg';
import reportToolComponentOverview from './icons/report-tool/components/overview.svg';
import reportToolComponentReference from './icons/report-tool/components/reference.svg';
import reportToolComponentScore from './icons/report-tool/components/score.svg';
import reportToolComponentSubtitle from './icons/report-tool/components/subtitle.svg';
import reportToolComponentTable from './icons/report-tool/components/table.svg';
import reportToolComponentText from './icons/report-tool/components/text.svg';
import attachmentPin from './icons/attachment-pin.svg';
import reload from './icons/reload.svg';
import warning from './icons/warning.svg';
import eiqLogo from './icons/eiq-logo.svg';
import home from './icons/home.svg';
import usersWhite from './icons/users-white.svg';
import masterdataWhite from './icons/masterdata-white.svg';
import notificationTool from './icons/notification-tool.svg';
import eiqAssess from './icons/eiq-assess.svg';
import jobsWhite from './icons/jobs-white.svg';
import eiqAnalyze from './icons/eiq-analyze.svg';
import eiqLearn from './icons/eiq-learn.svg';
import eiqLearnLogo from './icons/eiq-learn-logo.svg';
import notificationsBadgeWhite from './icons/notifications-badge-white.svg';
import eiq from './icons/eiq.svg';
import eiqSiteNavBtnSm from './icons/eiq-site-nav-btn-sm.svg';
import eiqAnalyzeNavBtnSm from './icons/eiq-analyze-nav-btn-sm.svg';
import eiqLearnNavBtnSm from './icons/eiq-learn-nav-btn-sm.svg';
import eiqAnalyzeNavBtnMd from './icons/eiq-analyze-nav-btn-md.svg';
import eiqLearnNavBtnMd from './icons/eiq-learn-nav-btn-md.svg';
import eiqAssessLrqaLogo from './icons/eiq-assess-lrqa-logo.svg';
import eiqLrqaSidebarCollapsed from './icons/eiq-lrqa-sidebar-collapsed.svg';
import eiqLrqaSidebarExpandedLogo from './icons/eiq-lrqa-sidebar-expanded-logo.svg';
import linked from './icons/link.svg';
import unlinked from './icons/unlinked.svg';
import blur from './icons/blur.svg';
import redact from './icons/redact.svg';
import happinessAngry from './icons/happiness_angry.svg';
import happinessSad from './icons/happiness_sad.svg';
import happinessOk from './icons/happiness_ok.svg';
import happinessHappy from './icons/happiness_happy.svg';
import happinessVeryHappy from './icons/happiness_very_happy.svg';
import menu from './icons/menu.svg';
import share from './icons/share.svg';
import surveyFinish from './icons/survey_finish.svg';
import surveyNext from './icons/survey_next.svg';
import surveyPrevious from './icons/survey_previous.svg';
import pending from './icons/icon-pending.svg';
import condition from './icons/condition.svg';
import validation from './icons/validation.svg';
import validationError from './icons/validation-error.svg';

// eslint-disable-next-line import/prefer-default-export
export const ICON = {
  block,
  btnAdd,
  checkbox,
  'checkbox-white': checkboxWhite,
  collapseIcon,
  expandIcon,
  cross,
  gear,
  pencil,
  search,
  'tail-spin': tailSpin,
  eye,
  'eye-cross': eyeCross,
  trash,
  minimize,
  remove,
  'question-type-audio': questionTypeAudio,
  'question-type-checkbox': questionTypeCheckbox,
  'question-type-currency': questionTypeCurrency,
  'question-type-date': questionTypeDate,
  'question-type-document': questionTypeDocument,
  'question-type-dropdown': questionTypeDropdown,
  'question-type-file': questionTypeFile,
  'question-type-number': questionTypeNumber,
  'question-type-radio': questionTypeRadio,
  'question-type-table': questionTypeTable,
  'question-type-text': questionTypeText,
  'question-type-relation': questionTypeRelation,
  'question-type-smiley-rating': questionTypeSmileyRating,
  'question-type-autofill': questionTypeAutofill,
  'happiness-angry': happinessAngry,
  'happiness-sad': happinessSad,
  'happiness-ok': happinessOk,
  'happiness-happy': happinessHappy,
  'happiness-very-happy': happinessVeryHappy,
  'question-type-star-rating': questionTypeStarRating,
  'new-page': newPage,
  logo,
  'logo-elevate': logoElevate,
  'jobs-big': jobsBig,
  'masterdata-big': masterdataBig,
  'users-big': usersBig,
  user,
  users,
  masterdata,
  jobs,
  help,
  check,
  dash,
  dashboard,
  hand,
  'arrow-l': arrowL,
  'arrow-r': arrowR,
  expand,
  plus,
  clone,
  funnel,
  download,
  'severity-critical': severityCritical,
  'severity-major': severityMajor,
  'severity-minor': severityMinor,
  'severity-moderate': severityModerate,
  'cap-approved': capApproved,
  'cap-pending': capPending,
  'cap-open': capPending,
  'cap-closed': capApproved,
  'cap-rejected': capRejected,
  serviceIconBlue,
  folder,
  'not-assigned': notAssigned,
  'misc-objects': miscObjects,
  text,
  'double-table': doubleTable,
  table,
  chart,
  language,
  info,
  error,
  'report-tool-break': reportToolBreak,
  'report-tool-chart': reportToolChart,
  'report-tool-chart-label': reportToolChartLabel,
  'report-tool-custom': reportToolCustom,
  'report-tool-double-table': reportToolDoubleTable,
  'report-tool-label': reportToolLabel,
  'report-tool-subtitle': reportToolSubtitle,
  'report-tool-table': reportToolTable,
  'report-tool-text': reportToolText,
  'report-tool-component-attachments': reportToolComponentAttachments,
  'report-tool-component-break': reportToolComponentBreak,
  'report-tool-component-chart': reportToolComponentChart,
  'report-tool-component-chart_legend': reportToolComponentChartLabel,
  'report-tool-component-double_table': reportToolComponentDoubleTable,
  'report-tool-component-findings': reportToolComponentFindings,
  'report-tool-component-breakdown': reportToolComponentBreakdown,
  'report-tool-component-label': reportToolComponentLabel,
  'report-tool-component-overview': reportToolComponentOverview,
  'report-tool-component-reference': reportToolComponentReference,
  'report-tool-component-scoring': reportToolComponentScore,
  'report-tool-component-subtitle': reportToolComponentSubtitle,
  'report-tool-component-table': reportToolComponentTable,
  'report-tool-component-text': reportToolComponentText,
  'sort-a-z': sortAZ,
  'sort-z-a': sortZA,
  notifications,
  information,
  'information-circle': informationCircle,
  alert,
  'notifications-badge': notificationsBadge,
  'attachment-pin': attachmentPin,
  reload,
  warning,
  'eiq-logo': eiqLogo,
  home,
  'users-white': usersWhite,
  'masterdata-white': masterdataWhite,
  'notification-tool': notificationTool,
  'eiq-assess': eiqAssess,
  'jobs-white': jobsWhite,
  eiq,
  'eiq-analyze': eiqAnalyze,
  'eiq-learn': eiqLearn,
  'eiq-learn-logo': eiqLearnLogo,
  'notifications-badge-white': notificationsBadgeWhite,
  'eiq-analyze-nav-btn-sm': eiqAnalyzeNavBtnSm,
  'eiq-site-nav-btn-sm' : eiqSiteNavBtnSm,
  'eiq-learn-nav-btn-sm': eiqLearnNavBtnSm,
  'eiq-analyze-nav-btn-md': eiqAnalyzeNavBtnMd,
  'eiq-learn-nav-btn-md': eiqLearnNavBtnMd,
  'eiq-assess-lrqa-logo': eiqAssessLrqaLogo,
  'eiq-lrqa-sidebar-collapsed': eiqLrqaSidebarCollapsed,
  'eiq-lrqa-sidebar-expanded-logo': eiqLrqaSidebarExpandedLogo,
  linked,
  unlinked,
  blur,
  redact,
  menu,
  share,
  'survey-finish': surveyFinish,
  'survey-next': surveyNext,
  'survey-previous': surveyPrevious,
  pending,
  condition,
  validation,
  'validation-error': validationError,
  arrowLeft,
  arrowRight
};
